import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
// Styles
import styles from './ContextMenu.module.css';

export function ContextMenu({
  actions, position, onClose, isDisplayed,
}) {
  // Ref
  const menuRef = useRef(null);

  const isMenuOutsideViewport = () => {
    if (menuRef?.current) {
      const rect = menuRef.current.getBoundingClientRect();
      return (position.y + rect.height) > window.innerHeight;
    }
    return false;
  };

  const [menuStyle, setMenuStyle] = useState({});

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && isDisplayed) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    setMenuStyle({
      top: position.y,
      left: position.x,
      transform: isDisplayed && isMenuOutsideViewport() ? 'translateY(-100%)' : null,
    });

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDisplayed, onClose]);

  // Handlers
  const handleOnClick = (onClick) => {
    onClick();
    onClose();
  };

  return (
    isDisplayed
    && actions?.some((action) => !action.hidden)
      ? (
        createPortal(
          (
            <div
              ref={menuRef}
              className={styles.menu}
              style={menuStyle}
            >
              <ul>
                {actions
                  .filter((action) => !action.hidden)
                  .map((action) => (
                    <li key={action.label}>
                      <button
                        className={styles.action}
                        type="button"
                        onClick={() => handleOnClick(action.onClick)}
                        style={action.style}
                        disabled={action.disabled}
                      >
                        {action.label}
                      </button>
                    </li>
                  ))}
              </ul>
            </div>
          ), document.body,
        )
      )
      : null
  );
}

ContextMenu.propTypes = {
  position: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    style: PropTypes.shape({}),
  })),
  onClose: PropTypes.func,
  isDisplayed: PropTypes.bool,
};

ContextMenu.defaultProps = {
  position: { x: 0, y: 0 },
  actions: [],
  onClose: undefined,
  isDisplayed: false,
};

export default ContextMenu;
